import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from './Tooltip'

import { withModals } from '../../contexts/modals'
import { withUserStore } from '../../contexts/UserStore'

const ButtonsView = ({ entry, modalActions, index, type, userStore }) => {
  const edit = (e) => {
    e.stopPropagation()
    if (entry.edit) entry.edit()
    else if (entry.editModal) modalActions.openModal(entry.editModal)
    else if (entry.editUrl) userStore.appNavigate(entry.editUrl)
  }

  const comment = (e) => {
    e.stopPropagation()
    if (entry.commentModal) modalActions.openModal(entry.commentModal)
  }

  const journal = (e) => {
    e.stopPropagation()
    if (entry.journalModal) modalActions.openModal(entry.journalModal)
  }

  const destroy = (e) => {
    e.stopPropagation()
    modalActions.openModal(
      {
        name: 'ConfirmationModal',
        header: `Delete ${entry.pageProvider.formName()}`,
        closeClicked: modalActions.closeModal,
        confirmClicked: confirmedDestroy,
        children: [`Are you sure you want to delete this ${entry.pageProvider.formName()}?`]
      })
  }

  const confirmedDestroy = () => {
    entry.pageProvider.destroy(entry.record)
    modalActions.closeModal()
  }

  return (
    <div className="button-group">
      {entry.pageProvider.showJournal &&
        <>
          <div onClick={(e) => journal(e)} id={`journal-button-${index}`} className="edit-icon"><i className="fas fa-book" /></div>
          <Tooltip delay={250} target={`journal-button-${index}`}>
            Journal...
          </Tooltip>
        </>}
      {entry.pageProvider.showComment &&
        <>
          <div onClick={(e) => comment(e)} id={`comment-button-${index}`} className="edit-icon"><i className="fas fa-comment" /></div>
          <Tooltip delay={250} target={`comment-button-${index}`}>
            Comment...
          </Tooltip>
        </>}
      {userStore.canUpdate(type, entry.editModal && entry.editModal.formRecord) &&
        <>
          <div onClick={(e) => edit(e)} id={`edit-button-${index}`} data-cy="edit-button" className="edit-icon"><i className="fas fa-pencil" /></div>
          <Tooltip delay={250} target={`edit-button-${index}`}>
            Edit...
          </Tooltip>
        </>}
      {userStore.canDelete(type, entry.editModal && entry.editModal.formRecord) &&
        <>
          <div onClick={(e) => destroy(e)} id={`delete-button-${index}`} className="edit-icon"><i className="fas fa-trash" /></div>
          <Tooltip delay={250} target={`delete-button-${index}`}>
            Delete...
          </Tooltip>
        </>}
    </div>
  )
}

ButtonsView.propTypes = {
  type: PropTypes.any.isRequired,
  entry: PropTypes.any.isRequired
}

export default withModals(withUserStore(ButtonsView))
